import { Occasions } from '@/types/occasion';
import { filterOccasions } from '@/utils/filterOccasions';
import storage from '@/utils/storage';

export const loadOccasions = (occasionData: Occasions[], isCartPresent?: boolean) => {
  const allOccasions = occasionData;
  const occasions = filterOccasions(allOccasions);
  if (!occasions.length) {
    return false;
  }
  storage.setItem('occasions', occasions);
  const currentOccasionData = occasions?.[0];
  const localStorageCurrentOccasion = storage.getItem('currentOccasion');
  const sessionCurrentOccasion = sessionStorage.getItem('currentOccasion');
  const storageCurrentOccasion = sessionCurrentOccasion && JSON.parse(sessionCurrentOccasion);

  if (
    !occasions.find((occasion) => occasion.id === localStorageCurrentOccasion?.id) &&
    currentOccasionData
  ) {
    storage.setItem('currentOccasion', occasions[0]);
    sessionStorage.setItem('currentOccasion', JSON.stringify(occasions[0]));
  }

  if (
    !occasions.find((occasion) => occasion.id === storageCurrentOccasion?.id) &&
    currentOccasionData
  ) {
    sessionStorage.setItem('currentOccasion', JSON.stringify(occasions[0]));
    // storage.setItem('currentOccasion', occasions[0]);
  }
  if (!isCartPresent) {
    const sessionOccasion = sessionStorage.getItem('currentOccasion');
    const SSOccasion = sessionOccasion && JSON.parse(sessionOccasion);

    if (localStorageCurrentOccasion?.id !== SSOccasion?.id) {
      storage.setItem('currentOccasion', occasions[0]);
    }
  }
  if (occasionExpired() && !isCartPresent) {
    const sessionOccasion = sessionStorage.getItem('currentOccasion');
    const SSOccasion = sessionOccasion && JSON.parse(sessionOccasion);

    if (localStorageCurrentOccasion?.id !== SSOccasion?.id) {
      storage.setItem('currentOccasion', occasions[0]);
    }
  }

  if (!occasions.find((occasion) => occasion.id === storageCurrentOccasion?.id)) {
    const { length } = occasions;
    const logos = ['Breakfast', 'Lunch', 'Snacks', 'Dinner'];
    for (let i = 0; i < length; i++) {
      occasions[i].logoName = '';
      for (let j = 0; j < logos.length; j++) {
        if (occasions[i].name.includes(logos[j])) {
          occasions[i].logoName = logos[j];
          break;
        }
      }
      if (occasions[i].name.includes('service') || occasions[i].name.includes('Service')) {
        occasions[i].logoName = 'Service';
      }
      if (!occasions[i].logoName) {
        occasions[i].logoName = 'Other';
      }
    }
  }
  return true;
};

export const isCurrentOccasion = (param?: any) => {
  const currentOccasion = storage.getItem('currentOccasion');
  const currentTime = param || new Date();
  const startTime = currentOccasion?.start_time?.split(':');
  const currentOccasionStart = new Date();
  currentOccasionStart.setHours(startTime[0]);
  currentOccasionStart.setMinutes(startTime[1]);
  currentOccasionStart.setSeconds(startTime[2]);

  const endTime = currentOccasion?.end_time?.split(':');
  const currentOccasionEnd = new Date();
  currentOccasionEnd.setHours(endTime[0]);
  currentOccasionEnd.setMinutes(endTime[1]);
  currentOccasionEnd.setSeconds(endTime[2]);

  return !!(currentTime >= currentOccasionStart && currentTime <= currentOccasionEnd);
};

export const occasionExpired = (param?: any) => {
  const currentOccasion = storage.getItem('currentOccasion');

  const currentTime = param || new Date();
  const startTime = currentOccasion?.start_time?.split(':');
  const currentOccasionStart = new Date();
  currentOccasionStart.setHours(startTime[0]);
  currentOccasionStart.setMinutes(startTime[1]);
  currentOccasionStart.setSeconds(startTime[2]);

  const endTime = currentOccasion?.end_time?.split(':');
  const currentOccasionEnd = new Date();
  currentOccasionEnd.setHours(endTime[0]);
  currentOccasionEnd.setMinutes(endTime[1]);
  currentOccasionEnd.setSeconds(endTime[2]);

  return !!(currentTime > currentOccasionStart && currentTime > currentOccasionEnd);
};

export const isPreorderToday = () => {
  const currentOccasion = storage.getItem('currentOccasion');
  const occasion = currentOccasion;
  return occasion.preorder_day === 'today';
};
